<template>
  <div class="service_manage" >
    <el-divider content-position="left">落地园区管理</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpen">新增</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table :data="placePark" size="medium" style="width: 100%" border>
      <el-table-column label='ID' width="80">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label='名称' width="100">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="80">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" circle 
          @click="handleEditOpen(scope.$index, scope.row)">
          </el-button>
          <el-popconfirm @onConfirm="handleDelete(scope.$index, scope.row)" confirmButtonText='确定'
            cancelButtonText='取消' icon="el-icon-info" iconColor="red" title="确定删除吗？">
            <el-button size="mini" type="danger" slot="reference" icon="el-icon-delete" circle>
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--页码-->
    <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
      :current-page="pageOption.currentPage" :page-sizes="[10, 20]" :page-size="pageOption.pageSize"
      :total="pageOption.total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加-->
    <el-drawer title="添加" :visible.sync="addDrawer" :direction="direction" :before-close="handleClose"
      size="40%">
      <div class="m-tabs-content">
        <el-form :model="formData" label-width="120px" :rules="rules" ref="formData">
          <el-form-item label="落地园区名称" prop="name">
            <el-input type="text" size="mini" placeholder="请输入落地园区名称" v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="float: right;margin-top: .4rem;" size="mini"
              @click="submitCheckForm('formData')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'service_manage',
  data () {
    return {
      inputSize: 'small',
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 15
      },
      addDrawer: false,
      saveDrawer: false,
      direction: 'rtl',
      placePark: [],
      formData: {
        id: '',
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入落地园区名称', trigger: 'blur' }
        ]
      },
      listSort: [],
    }
  },
  computed: { 
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getPlaceParkList () {
      this.$axios
        .get(
          '/api/admin/place_park/list?page=' +
          this.pageOption.currentPage,
        )
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.placePark = data.data.data.data
            this.pageOption.total = data.data.data.total
            this.pageOption.currentPage = data.data.data.current_page
            this.loadSort()
          }
        })
    },
    handleAddOpen () {
      this.formData.id = ''
      this.formData.name = ''
      this.addDrawer = true
    },
    submitCheckForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios.post('/api/admin/place_park', { formData: this.formData }).then((res) => {
            let { data } = res
            if (data.code === 0) {
              this.addDrawer = false
              this.getPlaceParkList()
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    handleEditOpen (index, row) {
      this.formData.id = row.id
      this.formData.name = row.name
      this.addDrawer = true
    },
    handleDelete (index, row) {
      this.$axios.get("/api/admin/place_park/delete?id=" + row.id).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.$message.error(data.msg)
          this.getPlaceParkList()
        }
      }).catch(_ => {})
    },
    loadSort () {
      this.placePark.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .post('api/admin/place_park/set_sort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getPlaceParkList()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.getPlaceParkList()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getPlaceParkList()
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {
        })
    },
    clearSaveData () {
      this.formData.id = ''
      this.formData.name = ''
    },
  },
  mounted () {
    this.getPlaceParkList()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .service_manage
    marginLeft()
  .mt-10
    margin-top: .2rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .service_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .addCon
    padding: .2rem
    text-align: right
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/PlacePark.vue